module.exports = __webpack_public_path__ + "img/copy-fill.eefbe626.svg";